import {
  ListItemCompetition,
  ListItemCompetitionProps,
} from './ListItemCompetition';
import { Competition } from 'functions/src/types/firestore/Game/Competition';
import { isPreReady } from 'functions/src/types/firestore/Game/Tournament/util';
import { TournamentPhase } from 'functions/src/types/firestore/Game/Tournament';
import { GradientBorder } from '../gradients/GradientBorder';

export function compareDates(a: Date, b: Date) {
  return (a ? a.getTime() : 0) - (b ? b.getTime() : 0);
}

export type CompetitionBoardProps = {
  competitions: (ListItemCompetitionProps &
    Pick<Competition<Date>, 'id' | 'date' | 'endDate'> & {
      phase: TournamentPhase;
    })[];
};

export function CompetitionBoard({ competitions }: CompetitionBoardProps) {
  return (
    <GradientBorder
      borderRadius={'10px'}
      sx={{
        maxHeight: '515px',
        overflowY: 'auto',
        listStyle: 'none',
        borderRadius: '10px',
        width: '100%',
        position: 'relative',
        zIndex: 1,
      }}
    >
      {competitions
        .sort((a, b) => {
          if (a.phase === 'live' || b.phase === 'live') {
            return a.phase === b.phase
              ? compareDates(a.date, b.date)
              : a.phase === 'live'
              ? -1
              : 1;
          }
          if (isPreReady(a.phase) && isPreReady(b.phase)) {
            return compareDates(a.date, b.date);
          }
          return compareDates(b.date, a.date);
        })
        .filter((competition) => {
          return !!competition.id;
        })
        .map((competition, index) => {
          return (
            <ListItemCompetition
              {...competition}
              noDivider={index === competitions.length - 1}
              key={competition.id}
              type={competition.type}
            />
          );
        })}
    </GradientBorder>
  );
}
